import { Container } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '@/commons/custom-breadcrumbs';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { PATH_DASHBOARD } from '@/routes/paths';
import { createOrdersService } from '@/services';
import { translates } from '@/utils';
import { errorOrders } from '@/utils/errors';
import { TITLE } from '@/utils/constants';
import { OrderNewEditForm } from '../form';
import { useFetch } from '../hooks/useFetch';

export const CreateListOrder = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [isGrid, setIsGrid] = useLocalStorage({ key: `${TITLE}/use-grid`, defaultValue: false });
    const {
      isLoading,
      fetchValues: onSubmitCreateOrder,
      // data: dataCreateOrder,
    } = useFetch({
      fetchFunction: createOrdersService,
      getData: true,
    });
    // const { fetchProperties: onSubmitAddOrderDetail } = useFetch({
    //   fetchFunction: addOrderDetailService,
    //   getData: true,
    // });
  
    const onCreateOrdersService = async (values: any) => {
      try {
        const resolve = await onSubmitCreateOrder(values);
        if (resolve.error) {
          const errorMessage = errorOrders[resolve?.error ?? resolve?.error.message] ?? 'Problemas Añadiendo Productos';
          enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });
        } else {
          navigate(PATH_DASHBOARD.orders.view(resolve?.id));
        }
      } catch (error) {
        const errorMessage = errorOrders[error?.error.message] ?? 'Problemas Añadiendo Productos';
        enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });
  
        if (error.data) enqueueSnackbar(`${error.data.name} `, { variant: 'info' });
        if (errorMessage.redirect) {
          navigate(PATH_DASHBOARD.orders.open_orders);
        }
        throw new Error(error);
      }
    };
  
    // const onSubmitAddOrderDetailService = async (id: string, items: any) => {
    //   try {
    //     const resolve = await onSubmitAddOrderDetail(id, items);
    //     navigate(PATH_DASHBOARD.orders.view(resolve?.id));
    //   } catch (error) {
    //     if (error?.message === 'not-have-ingredients-to-all-products') {
    //       enqueueSnackbar(`\n Producto :${error?.data?.name} \n Cantidad Posible : ${error.max}`, {
    //         variant: 'error',
    //       });
    //       enqueueSnackbar('Problemas Añadiendo Productos', { variant: 'error' });
    //     } else {
    //       enqueueSnackbar('Problemas Añadiendo Productos', { variant: 'error' });
    //     }
    //   }
    // };
  
    const handleSubmit = async (dataForm: any) => {
      try {
        const { items, ...rest } = dataForm;
        const valuesFormatted = dataForm?.items?.map?.((item: any) => {
          if (item.quantity + item.discountNumber < 1) {
            throw null;
          }
  
          const discountFlag = item.discountNumber > 0 && item.discount > 0;
          return {
            productId: Number(item.product.value),
            quantity: Number(item.quantity),
            description: item.description,
            discount: {
              discount: Number(discountFlag ? item.discount : 0),
              quantity_discount: Number(discountFlag ? item.discountNumber : 0),
            },
          };
        }) ?? [];
        await onCreateOrdersService({ ...rest, ordersDetails: valuesFormatted });
      } catch (error) {
        const errorMessage = new Error(error?.message);
  
        throw errorMessage;
      }
    };
    return (

        <Container maxWidth={false} sx={{ pb: 2 }}>
          <CustomBreadcrumbs
            heading={translates.new + translates.order}
            links={[
              { name: translates.dashboard, href: PATH_DASHBOARD.root },
              {
                name: translates.order,
                href: PATH_DASHBOARD.orders.root,
              },
              { name: `${translates.new} ${translates.order}` },
            ]}
            action={
              [
                // <Button
                //   variant="outlined"
                //   sx={{ width: { sm: 'auto', xs: '90vw' } }}
                //   color="info"
                //   onClick={() => setIsGrid((prev) => !prev)}
                // >
                //   {!isGrid ? [translates.gridMood] : [translates.listMood]}
                // </Button>,
              ]
            }
          />
          <OrderNewEditForm isGrid={isGrid} isLoading={isLoading} onSave={handleSubmit} />
        </Container>
    );
}